<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Account Settings
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-statuts"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Status
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-type-clients"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Types des clients
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-banks"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Liste des banques
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-social-links"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Lien social
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-transports"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Transports
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div class="row">
            <div class="col-12 mb-40">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Nom
                      </label>
                      <input
                        type="text"
                        class="form-control shadow-none rounded-0 text-black"
                        v-model="newStatut.name"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Code
                      </label>
                      <input
                        type="text"
                        class="form-control shadow-none rounded-0 text-black"
                        v-model="newStatut.code"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Couleur
                      </label>
                      <input
                        type="color"
                        class="form-control shadow-none rounded-0 text-black"
                        v-model="newStatut.code_color"
                      />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <button
                        class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                        type="submit"
                        style="float: right"
                      >
                        Save Changes
                      </button>
                      <!-- <button
                        type="button"
                        class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                    >
                        <i
                        class="flaticon-delete lh-1 me-1 position-relative top-2"
                        ></i>
                        <span class="position-relative">Cancel</span>
                    </button> -->
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <div class="col-12 mt-20">
              <h5 class="fs-16 fw-semibold mb-20">Liste des status</h5>
              <EasyDataTable
                :headers="headers"
                :items="statuts"
                buttons-pagination
              >
                <template #item-code_color="{ code_color }">
                  <div
                    :style="{
                      width: '40px',
                      height: '20px',
                      backgroundColor: code_color,
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                    }"
                  ></div>
                </template>

                <!-- Custom "actions" column -->
                <template #item-actions="{}">
                  <div class="buttons-list">
                    <button
                      type="button"
                      class="border-0 d-inline-block position-relative text-center transition"
                    >
                          <font-awesome-icon :icon="['far', 'fa-floppy-disk']" />
                    </button>
                  </div>
                </template>
              </EasyDataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import BlotFormatter from "quill-blot-formatter";
import ImageUploader from "quill-image-uploader";
import axios from "axios";
import api from "@/utils/axios";
// import Select2 from "@/components/Select2.vue";
import { useAppToast } from "@/composables/useAppToast";

export default defineComponent({
  name: "AccountSettings",
  //  components :{ Select2 },

  setup: () => {
    const { showToast } = useAppToast();
    const modules = {
      module: BlotFormatter,
      ImageUploader,
      options: {
        upload: (file: string | Blob) => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("image", file);

            axios
              .post("/upload-image", formData)
              .then((res: { data: { url: unknown } }) => {
                console.log(res);
                resolve(res.data.url);
              })
              .catch((err: unknown) => {
                reject("Upload failed");
                console.error("Error:", err);
              });
          });
        },
      },
    };
    const statuts = ref([]);

    const headers = [
      { text: "Code", value: "code" },
      { text: "Nom", value: "name" },
      { text: "Couleur", value: "code_color" },
      { text: "Actions", value: "actions" },
    ];

    const newStatut = reactive({
      name: "",
      code: "",
      code_color: "",
    });

    onMounted(async () => {
      fetchStatus();
    });

    async function fetchStatus() {
      try {
        const response = await api.get("/api/auth/status_list");
        if (response && response.data) {
          // handle the fetched cities data
          // console.log("Fetched cities:", response.data);
          statuts.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    }

    // Submit form
    async function submitForm() {
      try {
        const formData = new FormData();
        formData.append("name", newStatut.name);
        formData.append("code", newStatut.code);
        formData.append("code_color", newStatut.code_color);

        const response = await api.post("/api/auth/statut_add", formData);

        if (response.data.message == "success") {
          fetchStatus(); // Refresh the status list
          // Clear the form
          newStatut.name = "";
          newStatut.code = "";
          newStatut.code_color = "";
          showToast("Settings saved successfully!", "success");
        } else {
          showToast("Error: " + response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        showToast("An error occurred while saving settings.", "error");
      }
    }

    return {
      modules,
      statuts,
      headers,
      submitForm,
      newStatut,
    };
  },
});
</script>